import { ActorsUsersDetails } from "../../types";

export const getAUById = (id: string, actorUserDetails: ActorsUsersDetails[]): ActorsUsersDetails | null => {
    if (!actorUserDetails) return null;
    return actorUserDetails.find(au => au.id === id) || null;
}